{ "id": "coiffe-bouftou", "name": "Coiffe du Bouftou", "slot": "coiffe", "set": "bouftou", "tier": 2, "price": 120, "icon": "icons/items/coiffe-bouftou", "stats": { "force": 20, "intelligence": 20 } }
